
import { GlobalAuthProvider } from '@Stores/global/auth';

import { ThemeProvider } from '../Theme';

import AppErrorBoundary from './AppErrorBoundary';
import { AppLayoutProvider } from './context';

export default function AppWrapper({ children }) {
  return <GlobalAuthProvider>
    {/* <AppErrorBoundary> */}
    <ThemeProvider>
      <AppLayoutProvider>
        {children}
      </AppLayoutProvider>
      {/* </AppErrorBoundary> */}
    </ThemeProvider>
  </GlobalAuthProvider>
}

